import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { Button, useTheme } from '@mui/material';
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import PrivacyText from "./PrivacyText";
import { useNavigate } from 'react-router-dom';
import "./Terms.css";

function Privacy() {
  const theme = useTheme();

  return (
    <Box className="mainBox" sx={(theme) => ({ background: theme.palette.ke.background})}>
      <Card className="termsCard">
        <CardHeader title="Privacy Policy" sx={(theme) => ({ background: theme.palette.ke.card_header, textAlign: 'center', padding: '15px'})}/>
          <CardContent className="customCardContent">
            <PrivacyText/>
          </CardContent>
      </Card>
    </Box>
  );
}

export default Privacy;
